'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';



interface FooterLink {
  label: string;
  href: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

const Footer = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState(2025);

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear());
  }, []);

  const footerSections: FooterSection[] = [
  {
    title: "Services",
    links: [
    { label: "AI Agents Development", href: "/services" },
    { label: "Contract Staffing", href: "/services" },
    { label: "Data Engineering", href: "/services" },
    { label: "License Reselling", href: "/services" },
    { label: "Copilot Workshops", href: "/services" }]

  },
  {
    title: "Industries",
    links: [
    { label: "Technology & SaaS", href: "/industries" },
    { label: "Healthcare", href: "/industries" },
    { label: "BFSI", href: "/industries" },
    { label: "Retail & E-commerce", href: "/industries" },
    { label: "Manufacturing", href: "/industries" }]

  },
  {
    title: "Company",
    links: [
    { label: "About Us", href: "/about" },
    { label: "Careers", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "Privacy Policy", href: "/about" },
    { label: "Terms of Service", href: "/about" }]

  }];


  const socialLinks = [
  { name: "LinkedIn", icon: "LinkIcon", href: "#" },
  { name: "Twitter", icon: "LinkIcon", href: "#" },
  { name: "GitHub", icon: "LinkIcon", href: "#" }];


  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <Link href="/homepage" className="inline-flex items-center space-x-3 mb-6">
              {/* <div className="relative w-36 h-16 flex items-center justify-center">
                <AppImage
                  // src="/assets/images/logo_venka-1767350987369.png"
                 src="/assets/images/venklogonew.PNG" 
                  alt="Invictosoft Logo"
                  className="w-full h-full object-contain"
                  width={40}
                  height={40}
                />
              </div> */}
              <div className="relative w-36 h-16 flex items-center justify-center">
  <AppImage
    src="/assets/images/venklogonew.PNG"
    alt="Invictosoft Logo"
    fill
    className=" w-full h-full object-contain"
    sizes="144px"
  />
</div>
              <div className="flex flex-col">
                {/* <span className="text-lg font-headline font-bold leading-tight">Invictosoft</span> */}
                <span className="text-lg font-headline font-bold leading-tight">Invictosoft</span>
                <span className="text-xs font-body text-gray-300 leading-tight">Technology. Talent. Intelligence.</span>
              </div>
            </Link>
            <p className="text-sm text-gray-300 font-body mb-6 leading-relaxed max-w-md">
              Execution-focused technology partner delivering AI agents, contract staffing, and data engineering solutions. We don't just advise. We deliver.
            </p>
            















            <div className="flex items-center space-x-4">
              {socialLinks.map((social) => {}
              )}
            </div>
          </div>

          {footerSections.map((section) =>
          <div key={section.title}>
              <h3 className="text-base font-headline font-bold mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link) =>
              <li key={link.label}>
                    <Link
                  href={link.href}
                  className="text-sm text-gray-300 hover:text-accent font-body transition-colors duration-base">

                      {link.label}
                    </Link>
                  </li>
              )}
              </ul>
            </div>
          )}
        </div>

        <div className="border-t border-white border-opacity-20 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-sm text-gray-300 font-body">
              {/* &copy; {isHydrated ? currentYear : 2025} Invictosoft. All rights reserved. */}
              &copy; {isHydrated ? currentYear : 2025} Invictosoft. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link href="/about" className="text-sm text-gray-300 hover:text-accent font-body transition-colors duration-base">
                Privacy Policy
              </Link>
              <Link href="/about" className="text-sm text-gray-300 hover:text-accent font-body transition-colors duration-base">
                Terms of Service
              </Link>
              <Link href="/contact" className="text-sm text-gray-300 hover:text-accent font-body transition-colors duration-base">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;